const fiFIMessages: Record<string, string> = {
  'error-loading-page.text':
    'Voi ei, näyttää siltä, ettemme pysty lataamaan tätä osiota. Pahoittelemme, voitko yrittää uudelleen?',
  'error-loading-page.button': 'Yritä uudelleen',
  'shared.something-went-wrong-message': 'Hups!{br}Jotain meni pieleen!',
  'shared.something-went-wrong-description':
    'Emme löytäneet tätä linkkiä sovelluksesta.{br}Tarkista mahdolliset kirjoitusvirheet tai palaa kampanjan hallintapaneeliin.',
};

export default fiFIMessages;
